export default class PolicyNote {

	public note: string | null = null;
	public adminOnly: boolean | null = null;
	public isFlag: boolean | null = null;
	public flagDate: Date | null = null;
	public correspondenceRecvdOrSent: string | null = null;
	public correspondenceType: string | null = null;
	public correspondenceWho: string | null = null;
	public correspondenceSubject: string | null = null;
	public correspondenceReasons: string[] = [];
	public complaintInitiated: boolean | null = null;
	public correspondenceName: string | null = null;
	public correspondenceEmailAddress: string | null = null;
	public correspondencePhone1: string | null = null;
	public correspondencePhone2: string | null = null;

	public constructor() {

	}
};
